import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {SnackBarService} from '@q9elements/ui-kit/common';
import {CookieService} from 'ngx-cookie-service';
import {Observable} from 'rxjs';

import {environment} from '../../../environments/environment';

@Injectable()
export class AuthGuard {
  constructor(
    private cookieService: CookieService,
    private translate: TranslateService,
    private snackBarService: SnackBarService
  ) {}

  private getParameterByName(name, url): string {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let token = this.cookieService.get('auth-token');

    /** Check if token is inserted in url */
    const urlToken = this.getParameterByName('sign', window.location.href);
    if (urlToken) {
      this.cookieService.set('auth-token', urlToken);
      token = urlToken;
    }

    if (!token) {
      const redirectUrl = encodeURI(window.location.href);
      this.snackBarService.error('GENERAL.AUTH_ERROR');
      window.location.href = environment.MAIN_APP_URL + '/signin?redirect=' + redirectUrl;
    }
    return !!token;
  }
}
